// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___2VoHp","m-signature-pad--body":"styles__m-signature-pad--body___3gJRK","m-signature-pad--footer":"styles__m-signature-pad--footer___LGPIT","description":"styles__description___3F7xr","button":"styles__button___18FJN","clear":"styles__clear___33PgX","save":"styles__save___NOdS_","m-signature-pad":"styles__m-signature-pad___2GkzJ","github":"styles__github___3Qs00","loadingLabel":"styles__loadingLabel___2nzNE"};


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/components/InfiniteLoading/styles.scss
// module id = q+dO
// module chunks = client